// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_e6-0";
export var actionModalContentContainer = "_e6-1";
export var createTagButton = "_e6-2";
export var footerContainer = "_e6-7";
export var fullWidthDivider = "_e6-3";
export var hasCreateTagButton = "_e6-4";
export var noCreateTagButton = "_e6-5";
export var tagsContainer = "_e6-6";
export var tagsModalContentContainer = "_e6-8";